import { handleChangeUserData } from "../../redux/authentication"

export const handleImpersonate = (data, dispatch) => {

    if (localStorage.getItem("admin_user") === null) {
        localStorage.setItem("admin_user", localStorage.getItem("user"))
        localStorage.setItem('admin_token', localStorage.getItem('token'))
        localStorage.setItem('admin_refreshToken', localStorage.getItem('refreshToken'))
    }

    dispatch(handleChangeUserData(data))

    localStorage.setItem('token', data.token)
    localStorage.setItem('refreshToken', data.refreshToken)
}

export const handleLogoutImpersonate = (dispatch) => {

    dispatch(handleChangeUserData(JSON.parse(localStorage.getItem('admin_user'))))

    localStorage.setItem('token', localStorage.getItem('admin_token'))
    localStorage.setItem('refreshToken', localStorage.getItem('admin_refreshToken'))

    localStorage.removeItem('admin_token')
    localStorage.removeItem('admin_refreshToken')
    localStorage.removeItem('admin_user')
}